// extracted by mini-css-extract-plugin
export default {"header":"send_welcome_email_page___header___c2244f5a"};